module.exports = __webpack_public_path__ + "static/media/WorkExperiencePreparationeWorkExperience.41ecd214.pdf";